module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-detail"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.position))]), _vm._v(" "), _c('div', {
    staticClass: "cnPosition"
  }, [_vm._v("/ " + _vm._s(_vm.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "intro-wrapper"
  }, [_c('div', {
    class: {
      intro: _vm.intro
    },
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "needs",
    domProps: {
      "innerHTML": _vm._s(_vm.needs)
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "welfare"
  }, [_c('div', [_vm._v("實習生福利：")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("時薪：$190，之後視實際能力與貢獻增加")]), _vm._v(" "), _c('li', [_vm._v("彈性工作時間、實習周數與每週上班天數")]), _vm._v(" "), _c('li', [_vm._v("免費零食飲料咖啡氣泡水")]), _vm._v(" "), _c('li', [_vm._v("電影之夜，每季一次")]), _vm._v(" "), _c('li', [_vm._v("不定期舉辦 Workshop，課程內容開放大家提議")]), _vm._v(" "), _c('li', [_vm._v("社團活動與不定期 Teambuilding 活動")]), _vm._v(" "), _c('li', [_vm._v("運動 / 健身補助")]), _vm._v(" "), _c('li', [_vm._v("充分享受在 Spotify 音樂與垃圾話穿插夾雜的團隊樂趣")]), _vm._v(" "), _c('li', [_vm._v("接觸各領域的領導品牌客戶，參與超過上萬人使用的產品專案")]), _vm._v(" "), _c('li', [_vm._v("實習期間表現優異，我們將誠摯地歡迎您成為我們的正職夥伴")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-c5d4b3b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionJob/JobDetail.vue
// module id = 685
// module chunks = 0